<template>
  <div>
    <data-table :rows="rows.objects" :columns="columns" :has-pagination="false" :current-page="currentPage" @onSearch="searchFn">
      <template v-slot:actions="slotProps" v-if="checkForPermission(edit_shipment_permission)">
        <b-button v-b-modal.edit-shipment variant="secondary" size="sm" class="py-1 text-white" @click="setSelectedShipment(slotProps.row)">
          Edit Shipment
        </b-button>
      </template>
    </data-table>
    <b-modal
        id="edit-shipment"
        centered
        size="xl"
        hide-footer
        hide-header
        title-class="font-18">
      <div class="p-2">
        <h3>Edit Shipment</h3>
        <update-shipment-form button_text="Edit Shipment" :selected_shipment="selected_shipment"  :read-only-input="default_reads" @shipmentAction="editShipment"/>
        <b-button class="mt-3 float-end" variant="dark" block @click="$bvModal.hide('edit-shipment')" >Close</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import DataTable from "@/components/data-table";
import {mapActions} from "vuex";
import {successToast} from "@/components/successToast";
import UpdateShipmentForm from "@/components/shipment/update-shipment-form";
import moment from 'moment'
import {permissions} from "@/router/permissions";

export default {
name: "shipment-table",
  components: {UpdateShipmentForm, DataTable},
  data(){
    return{
      selected_shipment: {},
      edit_shipment_permission: permissions.edit_shipment_permission,
      default_reads: {
        warehouse: true,
        product: true,
        qty: true
      }
    }
  },
  props:{
    rows:{type:Object},
    columns:{type:Array},
    currentPage: {type: Number, default: 1}
  },
  methods: {
    ... mapActions({
      updateShipment: 'stock/updateShipment'
    }),
    setSelectedShipment(row){
      this.selected_shipment = {
        id: row.publicId,
        productId: row.productId.productName,
        warehouseId: row.warehouseId?.name,
        orderId: row.orderId,
        dateOrdered: moment(row.dateOrdered).format('YYYY-MM-DD'),
        expiryDate: moment(row.expiryDate).format('YYYY-MM-DD'),
        quantity: row.quantity,
        orderPrice: row.orderPrice
      }
    },
    async editShipment(data){
      data.id = this.selected_shipment.id
      await this.updateShipment(data).then(resp => {
        if(resp.publicId){
          this.$emit('updateShipmentData')
          successToast(`Shipment updated successfully`)
        }
      })
    },
    searchFn(data){
      this.$emit('onSearch', data)
    }
  }
}
</script>

<style scoped>

</style>
